import { isEnUS } from "./locale";
import { routeConstants } from "../constants";
import { CoreReduxState } from "../redux/store";
import { checkSegments } from "./util";

export const isEmailWinback = checkSegments({
  oneOf: [routeConstants.emailWinback],
});
export const isEmailMain = checkSegments({
  oneOf: [routeConstants.emailMain],
});

export const isFromEmail = checkSegments({
  oneOf: [isEmailMain, isEmailWinback],
});

/** Verifies if current user comes from an email blast */
export const isEmailBlast = (state?: CoreReduxState) => {
  const urlParams = new URLSearchParams(window.location.search);

  return isFromEmail(state) && urlParams.get("utm_source") === "blast";
};

export const isEnUSEmailWinback = checkSegments({
  required: isEnUS,
  oneOf: [isEmailWinback],
});

export const isEnUSEmailMain = checkSegments({
  required: isEnUS,
  oneOf: [isEmailMain],
});

export const isEnUSEmail = checkSegments({
  required: isEnUS,
  oneOf: [isFromEmail],
});
